import React, { useCallback } from "react";
import { useAuth } from "../../authentication/useAuth";
import Popup from "../../popup/Popup";
import Icon from "../../icon/Icon";
import UserMenuItem from "./UserMenuItem";
import { useCustomTranslation } from "../../../helpers/translateHelpers";

import UserOtherAccounts from "./UserOtherAccounts";
import { useNavigate } from "../../../helpers/navigationHelpers";

const UserMenu: React.FC = (): React.ReactElement => {
  const { user, onLogout } = useAuth();

  const { t } = useCustomTranslation();
  const navigate = useNavigate();

  const handleAfterClose = useCallback((action: () => Promise<void>) => {
    return (close: () => void) => {
      close();
      // Odložíme akci na další frame, aby React stihl zpracovat DOM cleanup popup
      requestAnimationFrame(() => {
        void action();
      });
    };
  }, []);

  if (!user) {
    return <div />;
  }

  const getUserInicials = () => {
    const splittedFullname = user.fullName.split(" ");

    return `${splittedFullname[0][0]}${splittedFullname[splittedFullname.length - 1][0]}`;
  };

  return (
    <Popup
      position="bottom right"
      trigger={
        <div className="border-gray-accent text-secondary absolute right-4 flex cursor-pointer flex-row items-center rounded-[10px] border-1 p-2 sm:right-8 sm:max-w-[300px] sm:p-4">
          <div className="bg-success mr-2.5 flex h-8 w-8 content-center items-center justify-center rounded-2xl text-center text-[14px]/[24px] font-semibold tracking-[-0.14px] text-white">
            <span>{getUserInicials()}</span>
          </div>
          <div className="mr-2.5 hidden sm:block sm:max-w-[150px]">
            <div className="overflow-hidden text-[15px]/[24px] font-semibold tracking-[-0.15px] overflow-ellipsis whitespace-nowrap">
              {user.fullName}
            </div>
            {user.fullName !== user.customerName && (
              <div className="text-secondary -mt-1 overflow-hidden text-[14px]/[20px] font-medium tracking-[-0.14px] overflow-ellipsis whitespace-nowrap">
                {user.customerName}
              </div>
            )}
          </div>
          <Icon name="chevron-down" />
        </div>
      }
    >
      {(close) => (
        <div className="w-[290px] p-8">
          <UserOtherAccounts />
          <hr className="border-gray bg-gray my-4" />
          <UserMenuItem
            label={t("settings")}
            onClick={() =>
              handleAfterClose(() => navigate.goTo("settings"))(close)
            }
          />
          <hr className="border-gray bg-gray my-4" />
          {/* <UserMenuItem
            label={t("feedback")}
            onClick={() => {
              close();
            }}
            className="mb-3"
          /> */}
          <UserMenuItem
            label={t("logout")}
            description={t("logout_description")}
            onClick={() => handleAfterClose(() => onLogout())(close)}
          />
        </div>
      )}
    </Popup>
  );
};

export default UserMenu;
